<header>
  <a href="https://github.com/kwsp/wordle">
    <h1>Wordle</h1>
  </a>
</header>

<style>
  header {
    display: flex;
    flex-direction: col;
    justify-content: center;
    border: 1px solid black;
  }
  h1 {
    margin: 0.5rem;
  }
</style>
